if (typeof Zmena_Stavu === 'undefined') {

    var Zmena_Stavu = {

        init: function () {
            var tlacitko = $('#tlacitko-hromadna-zmena-stavu-zadosti');
            if (!tlacitko.length) {
                return;
            }

            tlacitko
                .off('click')
                .on('click', function (e) {
                    e.preventDefault();

                    var grid = $('#grid_section_i103');
                    var rows = $(grid).jqGrid('getGridParam', 'selarrrow');
                    if (!rows.length) {
                        Lemo_Alert.addInfo('Pro změnu stavu označte alespoň jednu žádost', 'zmenaStavuZadostiInfo');
                        return;
                    }

                    var ids = [];
                    $.each(rows, function (i, id) {
                        ids.push(id);
                    });

                    $.ajax({
                        type: 'post',
                        url: '/plugin/PluginZadost/zmenaStavuZadostiFormularAjax',
                        dataType: 'json',
                        data: {'ids': ids},
                        global: false,
                        beforeSend: function () {
                            Lemo_Alert.closeAll();
                            Lemo_Alert.addInfo('Načítám formulář ...', 'zmenaStavuZadostiFormular');
                        },
                        complete: function () {
                            Lemo_Alert.closeById('zmenaStavuZadostiFormular');
                        },
                        success: function (data) {
                            Lemo_Alert.addMany(data.messages);
                            if (
                                false === data['status']
                                || !data.hasOwnProperty('html')
                                || !data['html'].length
                            ) {
                                return;
                            }

                            // modal
                            Lemo_Modal.setTitle('Změna stavu žádostí');
                            Lemo_Modal.setId('modal-hromadna-zmena-stavu');
                            Lemo_Modal.setContent(data.html);
                            Lemo_Modal.addButton('continue', 'Pokračovat', 'btn btn-primary', function () {
                                Lemo_Alert.closeAll();
                                var stavZadosti = $('#modal-novystav');
                                if (!stavZadosti.length || !stavZadosti.val()) {
                                    Lemo_Alert.addDanger('Vyberte cílový stav žádostí', 'zmenaStavuZadostiStav');
                                } else {

                                    var formData = {'ids': ids};
                                    formData['novystav'] = $('#modal-novystav').val();
                                    formData['poznamka'] = $('#modal-poznamka').val();
                                    formData['castkakomise'] = $('#modal-castkakomise').val();
                                    formData['datumdoporuceni'] = $('#modal-datumdoporuceni').val();
                                    formData['schvalenacastka'] = $('#modal-schvalenacastka').val();
                                    formData['typusneseni'] = $('[name="typusneseni"]:checked').val();
                                    formData['cislousneseni'] = $('#modal-cislousneseni').val();
                                    formData['datumpodpisusmlouvy'] = $('#modal-datumpodpisusmlouvy').val();
                                    formData['spisovaznacka'] = $('#modal-spisovaznacka').val();
                                    formData['uzavritdokument'] = $('#modal-uzavritdokument').is(':checked') ? 1 : 0;

                                    $.ajax({
                                        type: 'post',
                                        url: '/plugin/PluginZadost/zmenaStavuZadostiFormularAjax',
                                        dataType: 'json',
                                        data: formData,
                                        global: false,
                                        success: function (r) {
                                            if (r.hasOwnProperty('messages')) {
                                                Lemo_Alert.addMany(r.messages);
                                            }

                                            if (true === r.status) {
                                                formData = r.data;
                                                Zmena_Stavu.akce(stavZadosti.val(), formData);
                                                Lemo_Modal.close();
                                            }
                                        },
                                        error: function (xhr) {
                                            Lemo_Alert.addDanger('Došlo k neočekávané chybě');
                                        }
                                    });
                                }
                            });
                            Lemo_Modal.addButton('cancel', 'Zrušit', 'btn btn-default', function () {
                                Lemo_Alert.closeAll();
                                Lemo_Modal.close();
                            });
                            Lemo_Modal.build();

                            var stavZadosti = $('#modal-novystav');
                            stavZadosti.on('change', function() {
                                Plugin_Zadost.updateStateMiniform();
                            });
                        }
                    });
                });
        },

        /**
         * @param {number} stavId
         * @param {object} formData
         */
        akce: function (stavId, formData) {
            var grid = $('#grid_section_i103');
            var rows = $(grid).jqGrid('getGridParam', 'selarrrow');
            if (!rows.length) {
                return;
            }

            var ids = [];
            $.each(rows, function (i, id) {
                ids.push(id);
            });

            var progressId = 'zmena-stavu-zadosti-' + Math.round(new Date().getTime() + (Math.random() * 100));

            $.ajax({
                type: 'post',
                url: '/plugin/PluginZadost/zmenaStavuZadostiAjax',
                dataType: 'json',
                global: true,
                data: {'progressId': progressId, 'ids': ids, 'stavId': stavId, 'formData': formData},
                beforeSend: function () {
                    var text = '<p id="export-progress-eta">Příprava operace ...</p>';
                    text += '<div id="export-progress" class="progress text-center mb-3">';
                    text += '    <div class="progress-bar progress-bar-animated active" role="progressbar" style="width: 0;">0%</div>';
                    text += '</div>';
                    text += '<p id="export-progress-message" class="text-monospace"></p>';

                    Lemo_Alert.setShowCloseButton(false);
                    Lemo_Alert.setCloseOnClick(false);
                    Lemo_Alert.build('info', 'Změna stavu žádostí', text, 'zmenaStavuZadostiProgress', 0);
                    Lemo_Alert.setShowCloseButton(true);
                    Lemo_Alert.setCloseOnClick(true);

                    Plugin_Zadost.progressInterval = window.setInterval(function() {
                        Plugin_Zadost.ajaxProgress(progressId);
                    }, 2500);

                },
                success: function (data) {
                    if (data.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(data.messages);
                    }

                    var grid = $('#grid_section_i103');
                    grid.trigger('reloadGrid');
                },
                complete: function () {
                    Lemo_Alert.closeById('zmenaStavuZadostiProgress');
                    if (null !== Plugin_Zadost.progressInterval) {
                        window.clearInterval(Plugin_Zadost.progressInterval);
                        Plugin_Zadost.progressInterval = null;
                    }
                }
            });
        },

    };
}

$(document)
    .ready(function (){
        Zmena_Stavu.init();
    });